import { AiFillMail } from "react-icons/ai";
import { FiMessageSquare } from "react-icons/fi";
import { MdDownload } from "react-icons/md";
import { MdUpdate } from "react-icons/md";
import { BiMessageAltEdit, BiMessageSquareEdit } from "react-icons/bi";
import { MdUpload } from "react-icons/md";
import { BsChat, BsFillChatTextFill } from "react-icons/bs";
import AddOrderModal from "./AddOrderModal";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import { addCommas } from "@persian-tools/persian-tools";
export function ProductsRepair({ data2, updateSelectedItem, index, pageType }) {
  const statusPreview = (status) => {
    switch (status) {
      case 0:
        return " دریافت کالا و در انتظار بررسی";
        break;
      case 1:
        return " درحال بررسی";

        break;
      case 2:
        return "در حال تعمیر ";

        break;
      case 3:
        return "درحال تست";

        break;
      case 4:
        return "اماده تحویل ";

        break;
      default:
        return "نامعلوم";
        break;
    }
  };
  const typeOfOrdersPreview = (status) => {
    switch (status) {
      case 0:
        return " افلاین";
        break;
      case 1:
        return " انلاین";
        break;
      default:
        return "نامعلوم";
        break;
    }
  };
  // timestamo
  const timestampToDate = (time) => {
    if (time != "") {
      const a = time * 1000;
      const date = new DateObject({ date: a, calendar: persian });
      return date.format();
    }
  };
  let specialProducts = [],
    moreProducts = [];

  for (let index = 0; index < data2.items.length; index++) {
    if (index < 4) {
      specialProducts.push(
        <ProductsItem
          index={index}
          img={data2.items[index].img}
          title={data2.items[index].title}
          price={data2.items[index].main_price}
          desc={data2.items[index].description}
        ></ProductsItem>
      );
    } else {
      moreProducts.push(
        <ProductsItem
          index={index}
          img={data2.items[index].title}
          title={data2.items[index].title}
          price={data2.items[index].main_price}
          desc={data2.items[index].description}
          isMore={true}
        ></ProductsItem>
      );
    }
  }

  if (pageType == "user") {
    return (
      <div className="row order-item2 mx-4 mt-5 ">
        <div className="d-flex justify-content-flex-start mx-0 mt-3 flex-wrap ">
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>تاریخ ارسال </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {timestampToDate(data2.sendtm)}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>مبلغ کل </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {data2.Price.toLocaleString()} */}
              {addCommas(data2.total_amount)}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>مبلغ پرداخت شده </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {data2.paidAmount.toLocaleString()} */}
              {addCommas(data2.paid_amount)}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>مانده حساب </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {data2.debtAmount.toLocaleString()} */}
              {addCommas(
                data2.total_amount - data2.total_discount - data2.paid_amount
              )}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>نوع سفارش </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {typeOfOrdersPreview(data2.TypeOfOrders)} */}
              {typeOfOrdersPreview(+data2.order_type)}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>پیگیری </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {/* {data2.TrackingCode} */}
              {data2.send_trackingcode}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {statusPreview(data2.main_status)}
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-flex-start mx-0 mt-5 flex-wrap">
          {specialProducts}
        </div>

        <div className="d-flex  mt-3 p-4">
          <div
            style={{
              width: "65%",
              textAlign: "left",
              alignSelf: "center",
              display: "flex",
              justifyContent: "left",
            }}
          >
            {/* <span
              style={{
                color: "rgb(250, 5, 32)",
                fontSize: "16px",
              }}
            >
              {statusPreview(data2.orderStatus)}
            </span> */}
            <div className="accordion" id="accordionExample">
              <div>
                <h2 className="accordion-header" id="headingOne"></h2>
              </div>
            </div>
          </div>
        </div>
        <div
          id={`collapseOne-${index}`}
          className="accordion-collapse collapse "
        >
          <div className="accordion-body d-flex flex-wrap ">
            {moreProducts}
            <div></div>
          </div>
        </div>
        <div
          className="d-flex justify-content-between align-items-baseline admin-button"
          style={{ height: "auto" }}
        >
          {/* message icon */}
          <div
            data-tip=" پیام ها "
            onClick={() => {
              updateSelectedItem(data2);
            }}
            className="buttons"
            style={{
              color: "#457B9D",
              textDecoration: "none",
              marginRight: "10px",
              marginLeft: "7px",
              fontSize: "25px",
            }}
            data-bs-toggle="modal"
            data-bs-target="#StatusReportModal"
          >
            {/* {data2.Statusreport}  */}
            {
              // data2.chat[0].type == "user"
              data2.chats[data2.chats.length - 1] &&
              data2.chats[data2.chats.length - 1].type == "0" ? (
                <span
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    marginLeft: "7px",
                    fontSize: "25px",
                    title: "پیام",
                  }}
                >
                  <div className="position-relative">
                    {/* <BsChat></BsChat> */}
                    <BsFillChatTextFill />

                    <div className=" rounded-pill position-absolute blink-message"></div>
                  </div>
                </span>
              ) : (
                <BsFillChatTextFill />
              )
            }
            {/* {/* {MessageIcon()} */}
          </div>
          {/* accordion button */}
          <div
            data-bs-toggle="collapse"
            data-bs-target={`#collapseOne-${index}`}
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <div className="d-flex justify-content-center align-items-center">
              <a
                href="#"
                style={{
                  color: "#457B9D",
                  textDecoration: "none",
                  fontSize: "15px",
                }}
                className="mx-auto"
              >
                جزئیات بیشتر
              </a>
            </div>
          </div>
          {/* paid modal */}
          <div className="d-flex justify-content-end align-items-center paid-button">
            {data2.total_amount - data2.total_discount - data2.paid_amount >
            0 ? (
              <span
                data-tip="  تکمیل وجه "
                style={
                  {
                    // marginLeft: "15px",
                  }
                }
              >
                <button
                  style={{
                    marginLeft: "10px",
                    backgroundColor: "#10451d",
                    color: "white",
                    border: "none",
                    borderRadius: "15px",
                    padding: "8px 20px ",
                    fontSize: "18px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#ComolatePriceModal"
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                >
                  تکمیل وجه
                </button>
                <span
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "50px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#StatusReportModal"
                ></span>
              </span>
            ) : (
              <span></span>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="row order-item2 mx-4 mt-4 ">
        <div className="d-flex justify-content-flex-start mx-0 mt-3 flex-wrap ">
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>تاریخ ارسال </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {data2.ReceivedDate} */}
              {timestampToDate(data2.sendtm)}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>مبلغ کل </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {data2.Price.toLocaleString()} */}
              {addCommas(data2.total_amount)}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>مبلغ پرداخت شده </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {data2.paidAmount.toLocaleString()} */}
              {addCommas(data2.paid_amount)}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>مانده حساب </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {data2.debtAmount.toLocaleString()} */}
              {addCommas(
                data2.total_amount - data2.total_discount - data2.paid_amount
              )}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>نوع سفارش </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {typeOfOrdersPreview(data2.TypeOfOrders)} */}
              {typeOfOrdersPreview(+data2.order_type)}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>نام کاربر </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {/* {data2.NameUser} */}
              {`${data2.rescipient_fname} ${data2.rescipient_lname}`}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>موبایل </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {/* {data2.phone} */}
              {data2.rescipient_mobile}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>پیگیری </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {/* {data2.TrackingCode} */}
              {data2.send_trackingcode}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {statusPreview(data2.status)} */}
              {statusPreview(+data2.main_status)}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>آدرس: </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {/* {statusPreview(data2.status)} */}
              {data2.rescipient_address}
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-flex-start mx-0 mt-5 flex-wrap ">
          {specialProducts}
        </div>
        <div className="d-flex  mt-3 p-4">
          <div
            style={{
              width: "65%",
              textAlign: "left",
              alignSelf: "center",
              display: "flex",
              justifyContent: "left",
            }}
          >
            {/* <span
              style={{
                color: "rgb(250, 5, 32)",
                fontSize: "16px",
              }}
            >
              {statusPreview(data2.orderStatus)}
            </span> */}
            <div className="accordion" id="accordionExample">
              <div>
                <h2 className="accordion-header" id="headingOne"></h2>
              </div>
            </div>
          </div>
        </div>
        <div
          id={`collapseOne-${index}`}
          className="accordion-collapse collapse "
        >
          <div className="accordion-body d-flex flex-wrap ">
            {moreProducts}
            <div></div>
          </div>
          <div className="ms-5">
            ثبت کننده سفارش:
            <span>{`${data2.user_muid.fname} ${data2.user_muid.lname}`}</span>
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-between admin-button"
          style={{ height: "auto" }}
        >
          {/* edit/message icon */}
          <div className="d-flex align-items-center justify-content-start buttons">
            <span
              data-tip=" پیام ها "
              onClick={() => {
                updateSelectedItem(data2);
              }}
              style={{
                color: "#457B9D",
                textDecoration: "none",
                marginRight: "10px",
                marginLeft: "7px",
                fontSize: "25px",
              }}
              data-bs-toggle="modal"
              data-bs-target="#StatusReportModal"
            >
              {/* {data2.Statusreport}  */}
              {
                // data2.chat[0].type == "user" ?
                // data2.type == "1"
                data2.chats[data2.chats.length - 1] &&
                data2.chats[data2.chats.length - 1].type == "1" ? (
                  // <AiFillMail></AiFillMail>
                  <span
                    data-tip="پیام"
                    style={{
                      position: "relative",
                      marginRight: "10px",
                      marginLeft: "7px",
                      fontSize: "25px",
                    }}
                  >
                    <div className="position-relative">
                      {/* <BsChat></BsChat> */}
                      <BsFillChatTextFill />

                      <div className=" rounded-pill position-absolute blink-message"></div>
                    </div>
                  </span>
                ) : (
                  <BsFillChatTextFill />
                )
              }
              {/* {/* {MessageIcon()} */}
            </span>
            <span data-tip=" ویرایش تعمیرات">
              <span
                onClick={() => {
                  updateSelectedItem(data2);
                }}
                style={{
                  marginRight: "10px",
                  marginLeft: "7px",
                  fontSize: "25px",
                  color: "#457B9D",
                }}
                data-bs-toggle="modal"
                data-bs-target="#UpdateRepairModal"
              >
                <BiMessageSquareEdit />
                {/* <BiMessageAltEdit></BiMessageAltEdit> */}
              </span>
            </span>
          </div>
          {/* accordion button */}
          <div
            data-bs-toggle="collapse"
            data-bs-target={`#collapseOne-${index}`}
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <div className="d-flex align-items-center justify-content-center me-2">
              <div>
                <a
                  href="#"
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "15px",
                  }}
                  className="mx-auto"
                >
                  جزئیات بیشتر
                </a>
              </div>
            </div>
          </div>
          {/* paid modal */}
          <div className="d-flex align-items-center justify-content-end paid-button">
            {data2.total_amount - data2.total_discount - data2.paid_amount >
            0 ? (
              <span
                data-tip=" افزودن تکمیل وجه "
                style={
                  {
                    // marginLeft: "15px",
                  }
                }
              >
                <button
                  style={{
                    marginLeft: "10px",
                    backgroundColor: "#10451d",
                    color: "white",
                    border: "none",
                    borderRadius: "15px",
                    padding: "8px 20px ",
                    fontSize: "18px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#ComolatePriceModal"
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                >
                  افزودن تکمیل وجه
                </button>
                <span
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "50px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#StatusReportModal"
                ></span>
              </span>
            ) : (
              <span></span>
            )}
          </div>
        </div>
      </div>
    );
  }
}
function ProductsItem({ img, title, price, index, isMore, desc }) {
  return (
    <div className=" col-12 col-md-6 col-lg-6 col-child text-center mt-2 d-flex flex-column justify-content-between">
      {isMore && (
        <div
          style={{
            width: "90%",
            margin: "10px auto  0px auto",
          }}
        ></div>
      )}
      <div className="container-responsive2 d-flex justify-content-start  ">
        <span>
          <img
            src={`http://oilb.tatdemo.ir/${img}`}
            style={{ height: "150px", width: "150px", marginRight: "10px" }}
          ></img>
        </span>
        <span className="box-title mt-3 " style={{ textAlign: "right" }}>
          <p style={{ color: "#011c40", fontWeight: "bold", height: "30px" }}>
            {title}
          </p>
          <p style={{ color: "#fa0520", height: "30px" }}>
            {price && `${addCommas(price)}تومان`}
          </p>
          <p>{desc} </p>
        </span>
      </div>
      <div
        style={{
          borderBottom: "2px solid #dcdcdc",
          width: "90%",
          margin: "10px auto  0px auto",
        }}
      ></div>
    </div>
  );
}
